var _g, _rect, _g2, _rect2, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnique(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 61,
    viewBox: "0 0 43 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_122_3545)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.504395,
    width: 42.8886,
    height: 59.5675,
    rx: 5.95675,
    fill: "#FF7D1F"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_3545)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.95679,
    y: 6.461,
    width: 30.9751,
    height: 46.4626,
    rx: 2.3827,
    fill: "#FF8F3F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_122_3545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4622 36.6923H18.6361C14.7603 36.6923 12.71 34.3169 12.71 30.6162V19.7891C12.71 19.289 12.96 19.039 13.4601 19.039H16.4107C16.9107 19.039 17.1608 19.289 17.1608 19.7891V30.7662C17.1608 32.1415 17.6359 32.4415 18.6361 32.4415H24.4622C25.4624 32.4415 25.9375 32.1415 25.9375 30.7662V19.7891C25.9375 19.289 26.1875 19.039 26.6876 19.039H29.6382C30.1382 19.039 30.3883 19.289 30.3883 19.7891V30.6162C30.3883 34.3169 28.3379 36.6923 24.4622 36.6923Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.731,
    height: 50.0434,
    transform: "matrix(0.629622 0.776902 -0.792172 0.610298 36.0688 4.13776)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.69241,
    height: 47.1996,
    transform: "matrix(0.629622 0.776902 -0.792172 0.610298 40.8129 18.88)",
    fill: "white"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.55246,
    y: 7.05667,
    width: 29.7837,
    height: 45.2713,
    rx: 1.78702,
    stroke: "#C28017",
    strokeWidth: 1.19135
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_122_3545",
    x: 0,
    y: -0.686955,
    width: 42.8885,
    height: 61.9502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.3827,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_122_3545"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.19135
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "hard-light",
    in2: "shape",
    result: "effect1_innerShadow_122_3545"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.3827,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_122_3545"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.19135
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_122_3545",
    result: "effect2_innerShadow_122_3545"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_122_3545",
    x: 12.71,
    y: 19.039,
    width: 17.6783,
    height: 18.6533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_122_3545"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_3545"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.95679,
    y: 6.461,
    width: 30.9751,
    height: 46.4626,
    rx: 2.3827,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnique);
export default __webpack_public_path__ + "static/media/unique.db3728303198fca6cfc876866cfa59a7.svg";
export { ForwardRef as ReactComponent };